import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Form, Grid, Segment, Table, Button } from 'semantic-ui-react';
import _ from 'lodash';
import { CONTAINERS, resetView } from '../../../common/cardNavigationComponent/cardNavigationRedux';
import CustomDropdown from '../../../common/CustomDropdown';
import IButtonComponent from '../../../common/IButtonComponent';
import LocationCard from '../../../common/locationCard/LocationCard';
import {
  updateParentTaskTemplateItemOnKeyChange,
  updateAllParentTaskTemplateItemsWithKey,
  addChildToParentTaskTemplate,
} from './redux/actions';

export default function ParentTaskTemplateSegment({
  parentTaskTemplate,
  taskType,
  onParentTempalteSearchChange,
  onParentTempalteItemChange,
  formik,
  showEquipmentColumnForParentTemplate,
  task,
  onTemplateItemTaskTypeChanged,
}) {
  const dispatch = useDispatch();
  const onIButtonClicked = (assetId) => {
    dispatch(
      resetView(CONTAINERS.TASK_VIEW, {
        component: LocationCard,
        props: {
          locationId: assetId,
        },
      })
    );
  };
  useEffect(() => {
    if (_.get(formik, 'values.s_priority') && !task.id) {
      dispatch(
        updateAllParentTaskTemplateItemsWithKey({ keyValue: _.get(formik, 'values.s_priority'), key: 'priority' })
      );
    }
  }, [_.get(formik, 'values.s_priority'), dispatch]);

  useEffect(() => {
    if (_.get(formik, 'values.s_timetonextpriority') && !task.id) {
      dispatch(
        updateAllParentTaskTemplateItemsWithKey({
          keyValue: _.get(formik, 'values.s_timetonextpriority'),
          key: 'timeToNextPriority',
        })
      );
    }
  }, [_.get(formik, 'values.s_timetonextpriority'), dispatch]);

  const getOptionsForOperators = (item) => {
    let operatorOptions = item.assigneeOptions || [];
    const equipmentId = item.equipmentIdToEvaluate;
    const equipment = (item.equipmentOptions || []).find((val) => val.value === equipmentId);
    if (equipment?.originalobject?.vendorId) {
      operatorOptions = operatorOptions.filter(
        (val) => val.originalobject.vendorId === equipment?.originalobject?.vendorId
      );
    }
    return operatorOptions;
  };

  return (
    <Segment style={{ border: '1px solid #e5e5e5', marginTop: '10px' }} id="parentTaskTemplate">
      <Grid>
        <Grid.Row className="form-group-header">
          Template
          {/* <i style={{ fontSize: '12px', marginLeft: '5px' }}>
            (NOTE: If the child task specific location is left blank, the parent location will be used as a default)
          </i> */}
        </Grid.Row>

        {parentTaskTemplate.isLoading ? (
          <div className="hover-loading">
            <div className="joyn2-loader" />
          </div>
        ) : (
          <>
            {parentTaskTemplate.items.length > 0 && (
              <div style={{ width: '100%' }}>
                <Table id="partsTable">
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell width={1}>Step</Table.HeaderCell>
                      <Table.HeaderCell width={2}>TaskType Name</Table.HeaderCell>
                      <Table.HeaderCell width={2}>Location</Table.HeaderCell>
                      <Table.HeaderCell width={1} />
                      <Table.HeaderCell width={1}>Priority</Table.HeaderCell>
                      <Table.HeaderCell width={1}>Time To Next Priority(days)</Table.HeaderCell>
                      {showEquipmentColumnForParentTemplate && <Table.HeaderCell width={2}>Equipment</Table.HeaderCell>}
                      <Table.HeaderCell width={2}>Assignee/Operator</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  {parentTaskTemplate.items.map((item, index) => {
                    return (
                      <Table.Body key={item.originalItem.workflowStepId}>
                        <Table.Row>
                          <Table.Cell>{index + 1}</Table.Cell>
                          {!item.taskTypeChangeAllowed ? (
                            <Table.Cell>{item.taskTypeName}</Table.Cell>
                          ) : (
                            <Table.Cell style={{ paddingBottom: '20px' }}>
                              <Form.Field style={{ height: '50px' }} className="parentTemplateDropdown">
                                <CustomDropdown
                                  clearable
                                  style={{ marginBottom: '5px' }}
                                  placeholder="TaskType"
                                  fluid
                                  selection
                                  options={item.taskTypeOptionsToUse || []}
                                  value={item.originalItem.taskTypeId || ''}
                                  onChange={(event, data) => {
                                    onTemplateItemTaskTypeChanged(data, item, formik);
                                  }}
                                  search
                                />
                              </Form.Field>
                            </Table.Cell>
                          )}
                          <Table.Cell style={{ paddingBottom: '20px' }}>
                            <Form.Field style={{ height: '50px' }} className="parentTemplateDropdown">
                              <CustomDropdown
                                style={{ marginBottom: '5px' }}
                                clearable
                                placeholder="Location"
                                fluid
                                search
                                selection
                                options={item.assetOptions || []}
                                value={item.assetId || ''}
                                onChange={(event, data) => {
                                  onParentTempalteItemChange(data, item);
                                }}
                                onSearchChange={(event) => {
                                  onParentTempalteSearchChange(event, item, item.originalItem.taskTypeId);
                                }}
                                additionalInfo={item.selectedStop && item.selectedStop.name}
                                additionalInfoLabel="Stop"
                              />
                            </Form.Field>
                          </Table.Cell>
                          <Table.Cell>
                            <Form.Field>
                              <IButtonComponent
                                onClick={() => {
                                  onIButtonClicked(item.assetId);
                                }}
                                disabled={!item.assetId}
                              />
                            </Form.Field>
                          </Table.Cell>
                          <Table.Cell style={{ paddingBottom: '20px' }}>
                            <Form.Field style={{ height: '50px' }} className="parentTemplateDropdown">
                              <CustomDropdown
                                style={{ marginBottom: '5px' }}
                                placeholder="Priority"
                                fluid
                                selection
                                options={item.priorityOptions || []}
                                value={item.priority || ''}
                                onChange={(event, data) => {
                                  dispatch(
                                    updateParentTaskTemplateItemOnKeyChange({
                                      keyValue: data.value,
                                      key: 'priority',
                                      workflowStepId: item.originalItem.workflowStepId,
                                    })
                                  );
                                }}
                              />
                            </Form.Field>
                          </Table.Cell>
                          <Table.Cell style={{ paddingBottom: '20px' }}>
                            <Form.Field style={{ height: '50px' }} className="parentTemplateDropdown">
                              <CustomDropdown
                                style={{ marginBottom: '5px' }}
                                placeholder="Time To Next Priority(days)"
                                fluid
                                selection
                                options={item.timeToNextProrityOptions || []}
                                value={item.timeToNextPriority || ''}
                                onChange={(event, data) => {
                                  dispatch(
                                    updateParentTaskTemplateItemOnKeyChange({
                                      keyValue: data.value,
                                      key: 'timeToNextPriority',
                                      workflowStepId: item.originalItem.workflowStepId,
                                    })
                                  );
                                }}
                              />
                            </Form.Field>
                          </Table.Cell>

                          {showEquipmentColumnForParentTemplate && (
                            <Table.Cell style={{ paddingBottom: '20px' }}>
                              {item.needEquipment ? (
                                <Form.Field style={{ height: '50px' }} className="parentTemplateDropdown">
                                  <CustomDropdown
                                    style={{ marginBottom: '5px' }}
                                    placeholder="Equipment"
                                    search
                                    selection
                                    clearable
                                    options={item.equipmentOptions || []}
                                    value={item.equipmentIdToEvaluate || ''}
                                    onChange={(event, data) => {
                                      dispatch(
                                        updateParentTaskTemplateItemOnKeyChange({
                                          keyValue: data.value,
                                          key: 'equipmentIdToEvaluate',
                                          workflowStepId: item.originalItem.workflowStepId,
                                        })
                                      );
                                      let operatorId;
                                      const chosenOption = _.keyBy(data.options, 'value')[data.value];
                                      if (chosenOption && chosenOption.originalobject) {
                                        operatorId = chosenOption.originalobject.operatorId;
                                      }
                                      dispatch(
                                        updateParentTaskTemplateItemOnKeyChange({
                                          keyValue: operatorId ? [operatorId] : [],
                                          key: 'assigneeIdsToEvaluate',
                                          workflowStepId: item.originalItem.workflowStepId,
                                        })
                                      );
                                    }}
                                  />
                                </Form.Field>
                              ) : (
                                <>Not Applicable</>
                              )}
                            </Table.Cell>
                          )}

                          <Table.Cell style={{ paddingBottom: '20px' }}>
                            <Form.Field style={{ height: '50px' }} className="parentTemplateDropdown">
                              <CustomDropdown
                                style={{ marginBottom: '5px' }}
                                placeholder="Assignee/Operator"
                                search
                                selection
                                multiple
                                options={getOptionsForOperators(item)}
                                value={item.assigneeIdsToEvaluate || []}
                                onChange={(event, data) => {
                                  dispatch(
                                    updateParentTaskTemplateItemOnKeyChange({
                                      keyValue: data.value,
                                      key: 'assigneeIdsToEvaluate',
                                      workflowStepId: item.originalItem.workflowStepId,
                                    })
                                  );
                                }}
                                disabled={item.needEquipment && !item.equipmentIdToEvaluate}
                              />
                            </Form.Field>
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    );
                  })}
                </Table>
              </div>
            )}
            {taskType?.isDynamicParentChild && (
              <div style={{ marginBottom: '10px' }}>
                {formik?.errors?.parentTaskTemplate && (
                  <div className="errorText">*{formik.errors.parentTaskTemplate}</div>
                )}
                <Button
                  icon="add"
                  type="button"
                  onClick={() => {
                    dispatch(addChildToParentTaskTemplate(taskType));
                  }}
                  // disabled={buttonDisableState}
                >
                  Add Child
                </Button>
              </div>
            )}
          </>
        )}
      </Grid>
    </Segment>
  );
}
